import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";
import { IRecipeFormFields } from "../../sdk/utils/api/recipes";

export type IUseUpdateRecipeMutationParameters = Partial<IRecipeFormFields> & {
    id: string;
};

export const useUpdateRecipe = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IRecipe, unknown, IUseUpdateRecipeMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IRecipe, unknown, IUseUpdateRecipeMutationParameters>({
        mutationFn: (parameters: IUseUpdateRecipeMutationParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update recipe without authorization token.",
                );
            }

            return recipes.Recipe.update({ ...parameters, token: auth.token });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
